import React from 'react';

// Matches the interviewStatus values already used across your codebase:
// null/pending, scheduled, rescheduled, completed, accepted, rejected.
export const STATUS_OPTIONS = [
  { value: 'pending', label: 'Pending' },
  { value: 'scheduled', label: 'Scheduled' },
  { value: 'rescheduled', label: 'Re-Scheduled' },
  { value: 'completed', label: 'Completed' },
  { value: 'accepted', label: 'Accepted' },
  { value: 'rejected', label: 'Rejected' },
];

const STATUS_BADGE_CLASS = {
  pending: 'bg-gray-100 text-gray-700',
  scheduled: 'bg-blue-100 text-blue-700',
  rescheduled: 'bg-yellow-100 text-yellow-700',
  completed: 'bg-purple-100 text-purple-700',
  accepted: 'bg-green-100 text-green-700',
  rejected: 'bg-red-100 text-red-700',
};

/**
 * onChangeStatus(newStatus) is called for every selection EXCEPT "rejected" —
 * for "rejected" the parent should open the RejectReply modal instead, since
 * jobRequestStatusChange requires a mandatory rejectionReason.
 */
const StatusDropdown = ({ currentStatus, onChangeStatus, onSelectRejected }) => {
  const normalized = currentStatus || 'pending';

  const handleChange = (e) => {
    const next = e.target.value;
    if (next === normalized) return;
    if (next === 'rejected') {
      onSelectRejected();
      return;
    }
    onChangeStatus(next);
  };

  return (
    <div className="flex flex-col gap-1">
      <select
        value={normalized}
        onChange={handleChange}
        className="text-xs border border-[#DFDFDF] rounded px-1 py-0.5 focus:outline-none focus:ring-0"
      >
        {STATUS_OPTIONS.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default StatusDropdown;